(() => {
  if (window.zentronConversionInitialized) return;
  window.zentronConversionInitialized = true;
  const publish = (name, payload) => {
    try {
      if (window.Shopify?.analytics?.publish) {
        Promise.resolve(window.Shopify.analytics.publish(name, payload)).catch(() => {});
      }
    } catch (_) {}
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-zentron-product-click]');
    if (!link) return;
    publish('zentron:giveaway_product_click', {
      product_handle: link.dataset.zentronProductClick,
      position: link.dataset.clickPosition,
      destination_path: new URL(link.href).pathname,
      source_page: '/pages/q35-giveaway'
    });
  });
  const initializeBar = () => {
    const bar = document.querySelector('[data-q35-buybar]');
    if (!bar || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    const root = document.getElementById(`MainProduct-${bar.dataset.sectionId}`);
    if (!root) return;
    const variants = JSON.parse(bar.querySelector('[data-q35-variants]').textContent);
    const price = bar.querySelector('[data-q35-bar-price]');
    const media = window.matchMedia('(max-width:749px)');
    const update = () => {
      const button = root.querySelector('[id^="Product-Submit-Button-"]');
      const input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
      const variant = variants.find(item => String(item.id) === input?.value);
      if (variant) {
        bar.querySelector('[data-q35-bar-variant]').textContent = variant.title;
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency',currency:bar.dataset.currency || 'USD' }).format(variant.price / 100);
      }
      bar.hidden = !media.matches || !button || button.getBoundingClientRect().bottom >= 0 || document.documentElement.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden');
    };
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    };
    window.addEventListener('scroll', schedule, {passive:true});
    media.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled']});
    new MutationObserver(schedule).observe(document.body, {attributes:true,attributeFilter:['class']});
    bar.querySelector('[data-q35-options]').addEventListener('click', () => {
      publish('zentron:q35_purchase_bar_click', {product_handle:'q35',action:'choose_options'});
      requestAnimationFrame(() => root.querySelector('input[type="radio"]:checked,select')?.focus({preventScroll:true}));
    });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeBar,{once:true});
  else initializeBar();
  document.addEventListener('shopify:section:load',initializeBar);
})();
